<template>
  <div class="ccui-app-container-detail2">
    <div class="ccui-app-container-detail-body">
      <div style="margin-bottom: 10px" v-if="flag == 1">
        <!-- 尚未开标标，不能查看投标一览表 -->
        <el-alert
          class="alertColor"
          :title="$t('page.content.openning')"
          type="warning"
          :closable="false"
          show-icon
        >
        </el-alert>
      </div>
      <div style="margin-bottom: 10px" v-if="flag == 2">
        <!-- 你未投标，不能查看投标一览表 -->
        <el-alert
          class="alertColor"
          :title="
            `${
              purchaseType == 1 ||
              purchaseType == 4 ||
              purchaseType == 7 ||
              purchaseType == 8
                ? $t('page.content.opening2')
                : $t('page.content.opening1')
            }`
          "
          type="warning"
          :closable="false"
          show-icon
        >
        </el-alert>
      </div>
      <!-- 已结束 -->
      <div style="margin-bottom: 10px" v-if="flag == 4">
        <el-alert
          class="alertColor"
          :title="$t('page.content.closed')"
          type="warning"
          :closable="false"
          show-icon
        >
        </el-alert>
      </div>
      <!-- 已投标 其他类型 -->

      <div class="noBuy" v-if="flag == 3">
        <el-tabs class="el-tabs__customize" value="1">
          <el-tab-pane
            name="1"
            :label="
              `${
                purchaseType == 1 ||
                purchaseType == 4 ||
                purchaseType == 7 ||
                purchaseType == 8
                  ? '开启'
                  : '开标'
              }一览表`
            "
          >
            <!-- <hr style="border:1px solid #EDF2FC;width:100%" /> -->

            <div class="tableBox">
              <div v-if="subPackageFlag == 1">
                <el-table
                  :data="tableDataPack"
                  border
                  ref="table"
                  :span-method="spanMethodHandle"
                >
                  <!-- 序号 -->
                  <el-table-column
                    type="index"
                    :label="$t('page.content.No')"
                    width="55"
                    fixed
                  />
                  <!-- 供应商名称 -->
                  <el-table-column
                    prop="supName"
                    :label="$t('page.content.Supplier')"
                    min-width="180"
                    show-overflow-tooltip
                    fixed
                  ></el-table-column>
                  <!--各个包件部分-->
                  <el-table-column
                    prop="packName"
                    :label="tt.packName"
                    width="200"
                    v-for="(tt, index) in tableData"
                    :key="index"
                    align="center"
                  >
                    <el-table-column
                      prop="packBox"
                      :label="
                        `${
                          purchaseType == 1 ||
                          purchaseType == 4 ||
                          purchaseType == 7 ||
                          purchaseType == 8
                            ? $t('page.content.Amount1')
                            : $t('page.content.Amount')
                        }`
                      "
                      min-width="100"
                      align="right"
                    >
                      <!-- 投标金额（元） -->
                      <template slot-scope="{ row }">
                        <span v-if="row['priceAmount' + tt.packId] == null">
                        </span>
                        <span v-else>{{
                          (row["priceAmount" + tt.packId]
                            ? row["priceAmount" + tt.packId]
                            : 0) | bigNumberFormat(2)
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="coefficient"
                      label="系数"
                      align="center"
                    >
                      <template slot-scope="{ row }">
                        <span v-if="row['coefficient' + tt.packId] == null">
                        </span>
                        <span v-else>{{ row["coefficient" + tt.packId] }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="guidePrice"
                      label="基准价"
                      align="center"
                    >
                      <template slot-scope="{ row }">
                        <span v-if="row['guidePrice' + tt.packId] == null">
                        </span>
                        <span v-else>{{ row["guidePrice" + tt.packId] }}</span>
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <!-- 投标时间 -->
                  <el-table-column
                    prop="priceTime"
                    :label="
                      `${
                        purchaseType == 1 ||
                        purchaseType == 4 ||
                        purchaseType == 7 ||
                        purchaseType == 8
                          ? '响应'
                          : '投标'
                      }时间`
                    "
                    width="170"
                  >
                  </el-table-column>
                  <!--                <el-table-column-->
                  <!--                  prop="packBox"-->
                  <!--                  label="各包件报价情况"-->
                  <!--                  min-width="100"-->
                  <!--                >-->
                  <!--                  <template>-->
                  <!--                    &lt;!&ndash; 包件名称 &ndash;&gt;-->
                  <!--                    <el-table-column-->
                  <!--                      prop="packName"-->
                  <!--                      :label="tt.packName"-->
                  <!--                      width="200"-->
                  <!--                      v-for="(tt, index) in tableData"-->
                  <!--                      :key="index"-->
                  <!--                      align="right"-->
                  <!--                    >-->
                  <!--                      &lt;!&ndash; 投标金额（元） &ndash;&gt;-->
                  <!--                      <template slot-scope="{ row }">-->
                  <!--                        <span v-if="row['priceAmount' + tt.packId] == null">-->
                  <!--                        </span>-->
                  <!--                        <span v-else>{{-->
                  <!--                          (row["priceAmount" + tt.packId]-->
                  <!--                            ? row["priceAmount" + tt.packId]-->
                  <!--                            : 0) | bigNumberFormat(2)-->
                  <!--                        }}</span>-->
                  <!--                      </template>-->
                  <!--                    </el-table-column>-->
                  <!--                  </template>-->

                  <!--                  &lt;!&ndash; 投标时间 &ndash;&gt;-->
                  <!--                  <el-table-column-->
                  <!--                    prop="priceTime"-->
                  <!--                    label="投标时间"-->
                  <!--                    width="170"-->
                  <!--                  >-->
                  <!--                  </el-table-column>-->
                  <!--                </el-table-column>-->
                </el-table>
              </div>

              <div v-else>
                <el-table
                  border
                  v-if="tableData[0].sscSupIsBidPriceBOS.length > 0"
                  :data="tableData[0].sscSupIsBidPriceBOS"
                  :span-method="spanMethodHandle"
                >
                  <!-- 序号 -->
                  <el-table-column
                    type="index"
                    :label="$t('page.content.No')"
                    width="55"
                  />
                  <!-- 供应商名称 -->
                  <el-table-column
                    prop="supName"
                    :label="$t('page.content.Supplier')"
                  ></el-table-column>
                  <!-- 投标金额（元） -->
                  <el-table-column
                    prop="priceAmount"
                    :label="
                      `${
                        purchaseType == 1 ||
                        purchaseType == 4 ||
                        purchaseType == 7 ||
                        purchaseType == 8
                          ? $t('page.content.Amount1')
                          : $t('page.content.Amount')
                      }`
                    "
                    align="right"
                  >
                    <template slot-scope="{ row }">
                      <span>
                        {{
                          (row.priceAmount ? row.priceAmount : 0)
                            | bigNumberFormat(2)
                        }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="coefficient"
                    label="系数"
                    align="center"
                  >
                    <!-- <template slot-scope="{ row }">
                      <span v-if="row['coefficient' + tt.packId] == null">
                      </span>
                      <span v-else>{{ row["coefficient" + tt.packId] }}</span>
                    </template> -->
                  </el-table-column>
                  <el-table-column
                    prop="guidePrice"
                    label="基准价"
                    align="center"
                  >
                    <!-- <template slot-scope="{ row }">
                      <span v-if="row['guidePrice' + tt.packId] == null">
                      </span>
                      <span v-else>{{ row["guidePrice" + tt.packId] }}</span>
                    </template> -->
                  </el-table-column>
                  <!-- 投标时间 -->
                  <el-table-column
                    prop="priceTime"
                    :label="
                      `${
                        purchaseType == 1 ||
                        purchaseType == 4 ||
                        purchaseType == 7 ||
                        purchaseType == 8
                          ? '响应'
                          : '投标'
                      }时间`
                    "
                    width="170"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {
  qrySupBidOpenTotalDetailSub,
  qryBidOpenViewCheckSub
} from "@/app/myProjects/api/myProjectsEl.js";

export default {
  name: "bidOpeningListSub",
  components: {},
  mounted() {
    this.purchaseType = sessionStorage.getItem("purchaseType");
    this.agentId = this.$router.history.current.query.a;
    this.schemeId = sessionStorage.getItem("schemeId");
    this.supCode = sessionStorage.getItem("subcontractorCode");
    this.supName = sessionStorage.getItem("subcontractorName");
    this.qryBidOpenViewCheckSub();

    this.subPackageFlag = JSON.parse(sessionStorage.getItem("subPackageFlag"));
  },

  data() {
    return {
      purchaseType: "", //协议类型
      agentId: "",
      schemeId: "",
      supCode: "",
      supName: "",
      flag: "", //1 未开始 2 未投标 3已投标 4已结束
      tableDownloadData: [],
      tableUpData: [],
      tableBid: [],
      dialogTableVisibletextarea: false,
      tableDataPack: [],
      tableData: [],
      beginData: [],

      subPackageFlag: 0
    };
  },
  methods: {
    // 单元格合并
    spanMethodHandle({ column, rowIndex }) {
      let length = 1;
      if (this.subPackageFlag == "1") {
        // 分包件
        length = this.tableDataPack.length;
      } else {
        length = this.tableData[0].sscSupIsBidPriceBOS
          ? this.tableData[0].sscSupIsBidPriceBOS.length
          : 1;
      }
      // 系数和基准价合并
      if (
        column.property === "coefficient" ||
        column.property === "guidePrice"
      ) {
        // 把被合并的单元格设置为0,避免多出列
        if (rowIndex != 0) {
          return [0, 0];
        }
        return [length, 1];
      }
    },
    qryBidOpenViewCheckSub() {
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { agentId: this.agentId },
        { supCode: this.supCode }
      );
      qryBidOpenViewCheckSub(param).then(res => {
        if (res) {
          this.flag = res.data.data.checkFlag; //后面放开
          // this.flag = 3;
          let obj = {
            isShowexeTime: false,
            isShowTag: false,
            isShowLeftTime: false,
            isShowCouTime: false
          };
          this.$store.commit("edit", obj);
          if (this.flag == 3) {
            this.getSupBidOpenTotalDetail();
          }
        }
      });
    },
    getSupBidOpenTotalDetail() {
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { agentId: this.agentId }
      );
      qrySupBidOpenTotalDetailSub(param).then(res => {
        if (res) {
          this.tableData = res.data.data;
          let supData = [];
          this.tableData.forEach(item => {
            item.sscSupIsBidPriceBOS.forEach(tt => {
              this.$set(tt, "packId", item.packId);
              this.$set(tt, "packName", item.packName);
              let supIndex = supData.findIndex(
                item => item.supName == tt.supName
              );
              if (supIndex == -1) {
                tt["priceAmount" + tt.packId] = tt.priceAmount;
                tt["coefficient" + tt.packId] = item.coefficient;
                tt["guidePrice" + tt.packId] = item.guidePrice;
                tt["coefficient"] = item.coefficient;
                tt["guidePrice"] = item.guidePrice;
                // 系数、基准价
                supData.push(tt);
              } else {
                supData[supIndex]["priceAmount" + tt.packId] = tt.priceAmount;
                // 系数、基准价
                supData[supIndex]["coefficient" + tt.packId] = item.coefficient;
                supData[supIndex]["guidePrice" + tt.packId] = item.guidePrice;
                supData[supIndex]["coefficient"] = item.coefficient;
                supData[supIndex]["guidePrice"] = item.guidePrice;
              }
            });
          });
          this.tableDataPack = supData;
          console.log(supData, "supData...");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.noBegin {
  display: flex;
  justify-content: center;
  height: 500px;
  align-items: center;
  font-size: 18px;
  color: #4a4a4a;
}

/deep/.el-table__row {
  line-height: 36px;
  height: 36px;
}
/deep/.el-table td,
/deep/.el-table th {
  padding: 0;
}
</style>
